import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

export default (params, path) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'POST',
    url: path,
    data: params,
    headers: {
      token: decipher?.token?.value,
      action: 'update',
    }
  });
}
